import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {Keys, StorageService} from '../service/storage.service';

declare const fbq: any;
declare const ga: any;

@Injectable()
export class AnalyticsTracker {

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private storageService: StorageService) {
    }

    public createGoogleAnalyticsTracker(trackerId: string): void {
        if (isPlatformBrowser(this.platformId)) {
            ga('create', trackerId, 'auto');
        }
    }

    public trackConversion(): void {
        fbq('track', 'CompleteRegistration');
    }

    public trackButtonClick(eventCategory: string, eventAction: string, eventLabel?: string): void {
        ga('send', 'event', eventCategory, eventAction + ': button_click', eventLabel);
    }

    public trackError(errorDescription?: string): void {
        ga('send', 'exception', {'exDescription': errorDescription});
    }

    public trackPageView(pageUrl: string) {
        if (isPlatformBrowser(this.platformId)) {
            ga('set', 'page', pageUrl);
            ga('send', 'pageview');
        }
    }

    public setUserId() {
        if (isPlatformBrowser(this.platformId)) {
            ga('set', 'userId', this.storageService.getItem(Keys.PROFILE_ID));
        }
    }

    public sendAuthenticationEvent() {
        ga('send', 'event', 'authentication', 'user-id available');
    }
}
